import React, { useState } from "react";
import "./Accordion.css";

const AbutFaq = () => {
  const questions = [
    {
      question: "Commitment to customers:",
      answer:"We build strong, long-term relationships by consistently exceeding expectations and delivering clear added value. As trusted partners, we prioritize reliability, transparency, and innovation. Our commitment ensures stability and mutual growth, fostering a partnership that stands the test of time.",
    },
    {
      question: "Excellence in execution:",
      answer:"Our team is skilled at getting things done, leading with confidence, and pushing through challenges. With determination and resilience, we tackle obstacles head-on and find solutions. Their perseverance keeps us moving forward, ensuring success and growth.",
    },
    {
      question: "Fast Agility and Flexibility:",
      answer:"We stay ahead by anticipating and adapting to fast-changing market trends and globalization. With a strong presence both locally and internationally, we go beyond expectations. Our commitment ensures we deliver value and innovation to our stakeholders.",
    },
    {
      question: "Ideas and Innovation:",
      answer:"We are passionate about cutting-edge technologies and delivering high-value solutions to our customers. Our focus on innovation enhances both our offerings and operational excellence. We continuously strive to improve, ensuring top-quality results and customer satisfaction.",
    },
    {
      question: "Technology with (trusted) values:",
      answer:"Our technology fosters strong, sustainable connections between people and man-made processes. By enhancing efficiency and innovation, we create lasting relationships that drive progress. Our end users benefit from seamless, reliable, and future-ready solutions.",
    },
  ];

  const [expanded, setExpanded] = useState(Array(questions.length).fill(false));

  const toggleQuestion = (index) => {
    setExpanded((prev) =>
      prev.map((item, i) => (i === index ? !item : false)) // Ensures only one opens at a time
    );
  };

  return (
    <div className="container">
      <h1 className="heading">Values</h1>
      {questions.map((item, index) => (
        <div key={index}>
          <div
            className={`question-box ${!expanded[index] ? "collapsed" : ""}`}
            onClick={() => toggleQuestion(index)}
          >
            <span className="question-text">{item.question}</span>
            <div className={`arrow ${!expanded[index] ? "collapsed" : ""}`}></div>
          </div>
          <div className={`answer ${expanded[index] ? "open" : ""}`}>
            {item.answer}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AbutFaq;
